module.exports = __webpack_public_path__ + "static/media/124.ed845f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/124.jpg
// module id = 933
// module chunks = 0